export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value || 0);
};

// Moneda sin centavos (para valores enteros, p. ej. costos TBBC en COP).
export const formatCurrencyInt = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
};

export const formatPercentage = (value, total) => {
  if (!total || total === 0) return '0';
  return ((value / total) * 100).toFixed(1);
};
